module.exports = __webpack_public_path__ + "static/img/wx.a1e1a3b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/skin/images/wx.jpg
// module id = 5k2w
// module chunks = 20